export const Cards = [
  {
    title: 'Epic Movies Quotes',
    img: 'epic-movies-quotes',
    description:
      'This is a project where I use Next.js and Laravel Sanctum API to connect to the server and MySQL Database. The user can register, login, reset password and modify the profile. Once logged in, the user can post movies and quotes which will be posted in news feed for others to see and comment/like.',
    buttons: [
      {
        title: 'Go to Front-end Repository',
        link: 'https://github.com/Lythmass/Epic-Movie-Quotes-Frontend',
      },
      {
        title: 'Go to Back-end Repository',
        link: 'https://github.com/Lythmass/Epic-Movie-Quotes-Backend',
      },
    ],
    start: 'Jan, 5',
    end: 'Feb, 28',
  },
  {
    title: 'Coronatime',
    img: 'coronatime',
    description:
      'Website where the user can register, log in, verify email and reset password. Once logged in, the user can see the worldwide statistics about Coronavirus.',
    buttons: [
      {
        title: 'Go to Repository',
        link: 'https://github.com/Lythmass/Coronatime',
      },
    ],
    start: 'Nov, 28',
    end: 'Dec, 29',
  },
  {
    title: 'Covid Questionnaire',
    img: 'questionnaire',
    description:
      'This is a Vite React App consisting 4 pages of forms, inputs, radio buttons, checkboxes and library react-hook-forms are used to validate input texts in order to enable "Next Page" buttons and save the data in Context API which is sent to the server once submitted. ',
    buttons: [
      {
        title: 'Go to Repository',
        link: 'https://github.com/Lythmass/covid-questionnaire',
      },
    ],
    start: 'Dec, 26',
    end: 'Jan, 6',
  },
  {
    title: 'Quizzical App',
    img: 'quizzical',
    description:
      'Test your knowledge with this legendary quiz, which is written in React and the questions & answers come from API',
    buttons: [
      {
        title: 'Go to Repository',
        link: 'https://github.com/Lythmass/Quizzical-App',
      },
    ],
    start: 'Apr, 26',
    end: 'Apr, 25',
  },
];

export default Cards;
